import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=3ec3c2eb"
import script from "./Inform.vue?vue&type=script&lang=js"
export * from "./Inform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports